import React from 'react';
import { useTranslation } from 'react-i18next';
import { Forbes, WallStreetJournal, Wired, ConsumerReports, CNN } from '/src/images/home';

const Featured = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.featured' });

	return (
		<section className="featured">
			<div className="content-wrapper">
				<img src={Forbes} alt={t('forbes-magazine')} />
				<hr />
				<p>{t('using-a-combination')}</p>

				<div className="icon-row">
					<img src={WallStreetJournal} alt={t('the-wall-street-journal')} />
					<img src={Wired} alt={t('wired')} />
					<img src={ConsumerReports} alt={t('consumer-reports')} />
					<img src={CNN} alt={t('cnn')} />
				</div>
			</div>
		</section>
	);
};

export default Featured;
